import { styled } from '@mui/material/styles';

import { Concrete } from '../../StyleGuide/Colors';

export const InProgressBackdrop = styled('div')({
  background: `linear-gradient(white, ${Concrete})`,
  padding: '0 0 42px'
});
